import { render } from "./selectComunidad.vue?vue&type=template&id=c1324b42"
import script from "./selectComunidad.vue?vue&type=script&lang=ts"
export * from "./selectComunidad.vue?vue&type=script&lang=ts"
script.render = render

export default script